<mat-card class="card">
  <mat-card-content class="cardContent">
    <div class="d-flex">
      <div class="d-flex flex-column">
        <div class="d-flex flex-column align-items-center py-2">
          <div class="d-flex align-items-center">
            <h4 data-testId="date-range-start-date" class="d-flex justify-content-center mb-0 inlineCalendarWidth">
              {{startDate ? (startDate | date:'mediumDate') : defaultStartDateLabel}}
            </h4>
            <mat-icon data-testId="date-range-right-arrow" svgIcon="arrow-right" class="icon--large"></mat-icon>
            <h4 data-testId="date-range-end-date" class="d-flex justify-content-center mb-0 inlineCalendarWidth">
              {{endDate ? (endDate | date:'mediumDate') : defaultEndDateLabel}}
            </h4>
          </div>

          <div class="w-100 text-center mt-1 text-muted">{{startDate | dateDiff : endDate}}</div>
        </div>

        <hr class="my-0" />

        <div class="d-flex justify-content-center cardContent_calendars">
          <mat-calendar
            data-testId="start-date-calendar"
            class="inlineCalendar inlineCalendarWidth"
            #startCalendar
            [(selected)]="startDate"
            [maxDate]="endDate"
            [minDate]="minimumStartDate"
          ></mat-calendar>

          <span class="verticalSeparator"></span>

          <mat-calendar
            data-testId="end-date-calendar"
            class="inlineCalendar inlineCalendarWidth"
            #endCalendar
            [(selected)]="endDate"
            [maxDate]="maximumEndDate"
            [minDate]="startDate"
          ></mat-calendar>
        </div>
      </div>

      <span class="verticalSeparator"></span>

      <div class="d-flex flex-column w-100 p-2 filterButtonsColumn">
        <button
          *ngFor="let presetRange of presetRanges"
          mat-button
          [attr.data-testId]="presetRange.name"
          (click)="onRangeSelection(presetRange)"
          [color]="(presetRange | dateRangePresetComparer : presetRanges : startDate: endDate) ? 'primary': ''"
        >
          {{presetRange.name}}
        </button>
      </div>
    </div>
  </mat-card-content>

  <mat-card-actions *ngIf="useExplicitActions" class="cardFooter">
    <button data-testId="date-range-apply" mat-flat-button class="mat-secondary" (click)="onApply()">
      <mat-icon svgIcon="check"></mat-icon>
      <span i18n="@@dpr.dateRangePicker.btnApply">Apply</span>
    </button>
    <button data-testId="date-range-cancel" mat-button color="primary" (click)="onCancel()">
      {{StaticMessage.CancelButton | staticMessage}}
    </button>
    <button
      data-testId="date-range-clear"
      *ngIf="startDate || endDate"
      mat-button
      color="primary"
      i18n="@@dpr.dprFilters.btnClear"
      (click)="onClear()"
    >
      Clear
    </button>
  </mat-card-actions>
</mat-card>
